// 1
import 'babel-polyfill'
import fetch from 'unfetch'
import 'es6-promise/auto'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

import Vue from 'vue'
import store from './vuex/index'
// 2
import VueApollo from 'vue-apollo'
import App from './App'
import router from './router'
import VueVisible from 'vue-visible'
import VueObserveVisibility from 'vue-observe-visibility'
import VModal from 'vue-js-modal'
import de from 'vee-validate/dist/locale/de'
import VeeValidate, { Validator } from 'vee-validate'
Validator.localize('de', de)
Vue.use(VueObserveVisibility)
Vue.use(VueVisible)

const SocialSharing = require('vue-social-sharing')
Vue.use(SocialSharing)
Vue.use(VModal)

require('intersection-observer')

const config = {
  errorBagName: 'errors',
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'de',
  dictionary: null,
  strict: true,
  classes: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'uk-form-success', // model is valid
    invalid: 'uk-form-danger', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true,
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations' // the nested key under which the validation messsages will be located
}
Vue.use(VeeValidate, config)

Vue.config.productionTip = false

// 3
const httpLink = new HttpLink({
  uri: 'http://api-martinsorgel.klangpatenschaft.de/graphql/',
  method: 'POST',
  fetch: fetch,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }
})

// 4
const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

// 5
Vue.use(VueApollo)

// 6
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: 'loading'
  }
})

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  // 7
  provide: apolloProvider.provide(),
  router,
  ...App,
  store
})

export { app, router, store }



// WEBPACK FOOTER //
// ./src/main.js